import { HttpContextToken } from '@angular/common/http';

import { KeyRefreshEnum } from '../enums/key-refresh';
import { PropertyProfile } from '../store/models/property-profile.model';

export interface AuthenticateUserResponse {
  d: {
    AgreementHtml: string | null;
    AgreementVersion: string | null;
    Key: string | null;
    Status: string;
    StatusCode: string;
    __type: string;
  };
}

export interface RefreshKeyResponse {
  d: {
    AgreementHtml: string | null;
    AgreementVersion: string | null;
    Key: string | null;
    Status: string;
    StatusCode: string;
    __type: string;
  };
}

export interface FindByAddressResponse {
  d: PropertyProfile;
}

export const ShouldRefreshKey = new HttpContextToken<KeyRefreshEnum>(() => KeyRefreshEnum.None);
export const ShouldIgnoreLoader = new HttpContextToken<boolean>(() => false);
export const ShouldConvertStatusCodeErrors = new HttpContextToken<boolean>(() => false);
export const ShouldConvertWalkingFarmCountErrors = new HttpContextToken<boolean>(() => false);
export const ShouldUseErrorMessageFromDescription = new HttpContextToken<boolean>(() => false);
